"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageSwitcher = void 0;
var _List = _interopRequireDefault(require("@material-ui/core/List"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _Translations = require("../Translations");
var _LanguageSwitcher = require("../LanguageSwitcher/LanguageSwitcher");
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@material-ui/core/styles");
var _reactRedux = require("react-redux");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    list: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    listItem: {
      flexDirection: 'column',
      padding: '6px'
    },
    listItemActive: {
      backgroundColor: 'rgba(0, 0, 0, 0.10)',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.10)'
      }
    }
  };
});
// We use it in login and register pages
var LanguageSwitcher = function LanguageSwitcher(props) {
  var classes = useStyles();
  var enabledLanguages = _lodash.default.uniq([_Translations.DEFAULT_LANGUAGE].concat(_toConsumableArray(_Translations.OTHER_LANGUAGES)));
  var _useSelector = (0, _reactRedux.useSelector)(function (_ref) {
      var localeReducer = _ref.localeReducer;
      return {
        locale: localeReducer.locale
      };
    }),
    locale = _useSelector.locale;
  var dispatch = (0, _reactRedux.useDispatch)();
  var handleLanguageChange = function handleLanguageChange(locale) {
    dispatch({
      type: 'SWITCH_LOCALE_WITH_COOKIES',
      locale: locale,
      reload: true
    });
  };
  if (enabledLanguages.length < 2) return null;
  return /*#__PURE__*/_react.default.createElement(_List.default, {
    className: classes.list
  }, enabledLanguages.map(function (enabledLanguage) {
    var language = _LanguageSwitcher.languages.find(function (language) {
      return language.id === enabledLanguage;
    }) || _LanguageSwitcher.languages[0];
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      className: (0, _classnames.default)(classes.listItem, _defineProperty({}, classes.listItemActive, locale === enabledLanguage)),
      key: language.id,
      onClick: function onClick() {
        return handleLanguageChange(language.id);
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://s2.svgbox.net/flags-hd.svg?ic=".concat(language.flag),
      alt: language.name,
      width: 22,
      height: 22
    }));
  }));
};
exports.LanguageSwitcher = LanguageSwitcher;